import { html, View } from 'rune-ts';
import { copyText, shareUrl } from '../../lib/share.ts';

export type RoomCodeDisplayData = {
  code: string;
  shareUrl: string;
};

export class RoomCodeDisplayView extends View<RoomCodeDisplayData> {
  override template() {
    const { code } = this.data;
    const formatted = formatCodeForDisplay(code);
    return html`
      <section class="room-code-card flex flex-col items-center gap-2 rounded-2xl bg-wood-paper ring-1 ring-wood-sand p-4">
        <div class="flex flex-col items-center">
          <div class="text-xs text-wood-coffee/70">룸 코드</div>
          <div class="text-3xl font-extrabold tracking-widest text-card-brass">${formatted}</div>
        </div>
        <div class="flex gap-2 mt-1">
          <button
            type="button"
            data-role="copy-code"
            class="rounded-lg bg-wood-bark hover:bg-wood-coffee text-wood-paper px-3 py-1.5 text-xs"
          >
            코드 복사
          </button>
          <button
            type="button"
            data-role="copy-link"
            class="rounded-lg bg-wood-bark hover:bg-wood-coffee text-wood-paper px-3 py-1.5 text-xs"
          >
            링크 복사
          </button>
        </div>
      </section>
    `;
  }

  protected override onMount(): void {
    const root = this.element();
    root
      .querySelector<HTMLButtonElement>('[data-role="copy-code"]')
      ?.addEventListener('click', () => {
        void copyText(this.data.code);
      });
    root
      .querySelector<HTMLButtonElement>('[data-role="copy-link"]')
      ?.addEventListener('click', () => {
        void shareUrl(this.data.shareUrl);
      });
  }
}

function formatCodeForDisplay(code: string): string {
  if (code.length !== 6) return code;
  return `${code.slice(0, 3)} ${code.slice(3)}`;
}
